import React from "react";

const UserDashboardProgressTable = ({ game }) => {
  const isMatchGabor = game?.gameName?.includes("Match Gabor");

  const gameDuration = isMatchGabor ? 600 : 300;
  const remainingTime = game?.remainingTime < 10 ? 0 : (game?.remainingTime || 0);
  const timePlayed = gameDuration - remainingTime;
  const finalProgress = Math.min(100, Math.max(0, Math.ceil((timePlayed / gameDuration) * 100)));

  return (
    <tr className="hover:bg-slate-50/50 transition duration-150">
      <td className="px-6 py-4 font-bold text-slate-800 text-sm">
        {game?.gameName}
      </td>
      <td className="px-6 py-4 text-xs font-semibold text-slate-400 whitespace-nowrap">
        {game?.date} at {game?.time || "N/A"}
      </td>
      <td className="px-6 py-4 text-sm font-semibold text-slate-500 text-right min-w-[140px]">
        <div className="flex items-center gap-3 justify-end">
          <div className="h-2 w-24 bg-slate-100 rounded-full overflow-hidden border border-slate-200/50">
            <div
              className="h-full bg-secondary rounded-full"
              style={{ width: `${finalProgress}%` }}
            />
          </div>
          <span className="text-xs font-bold text-slate-700 w-8 text-right">{finalProgress}%</span>
        </div>
      </td>
    </tr>
  );
};

export default UserDashboardProgressTable;
